import { Modal } from 'antd'
import styled from 'styled-components'
import Flex from '../../Flex'

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 1rem !important;
    padding: ${({ padding }) => padding || '1rem'};
    text-align: center;
  }
`
export const ShortlistDiv = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: ${props => props.fontSize || '20px'};
  font-weight: ${props => props.fontWeight || 500};
  line-height: ${props => props?.percentHeight || '28px'};
  letter-spacing: 0em;
  text-align: center;
  color: #010e30;
  height: ${props => props?.percentHeight || 'auto'};
  white-space: ${props => (props?.nowrap ? 'nowrap' : 'normal')};
  /* width: ${props => props?.percentWeight || '451px'}; */
  margin-top: 15px;
  margin-bottom: 15px;
`
export const TextDescription = styled.p`
  width: 80%;
`

export const UploadMsgFlex = styled(Flex)`
  height: 100%;
  gap: 1rem;
`

export const ContainerStyle = styled.div`
  text-align: left;
  padding-top: 10px;
`
export const CountStyle = styled.div`
  text-align: right;
  width: 100%;
`
export const LabelWrapper = styled.p`
  font-weight: 600;
  font-size: 14px;
  color: #999fac;
  white-space: nowrap;
  margin-bottom: 0 !important;
`
